import authApi from '@/authApi';

export default {
  namespaced: true,
  state: () => ({
    isBrandingLoaded: false,
    isBranded: false,
    branding: null
  }),
  mutations: {
    setBranding (state, branding) {
      state.branding = branding;
    },
    setIsBranded (state, isBranded) {
      state.isBranded = isBranded;
    },
    setIsBrandingLoaded (state, isLoaded) {
      state.isBrandingLoaded = isLoaded;
    }
  },
  actions: {
    async fetchBranding ({ commit }, brandTemplate) {
      if (!brandTemplate) {
        commit('setIsBranded', false);
        commit('setIsBrandingLoaded', true);
        return;
      }

      const response = await authApi.get('branding/' + brandTemplate);
      if (response && response.status === 200) {
        commit('setBranding', response.data);
        commit('setIsBranded', !!response.data);
      }
      commit('setIsBrandingLoaded', true);
    }
  }
};
